import React, { useState, useEffect } from 'react';
import './Communications.css';

const Communications = ({ customer, updateCustomer }) => {
  const [preferences, setPreferences] = useState({
    receiveEmails: true,
    interests: {
      eventsAndCommunity: true,
      culturalMatters: true,
      inHouseKnowledge: true,
    },
    seasonalSensitivities: {
      mothersDay: true,
      fathersDay: true,
      valentinesDay: true,
    },
  });

  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    const savedPrefs = localStorage.getItem('physCommunicationPrefs');
    if (savedPrefs) {
      try {
        setPreferences(JSON.parse(savedPrefs));
      } catch (error) {
        console.error('Error loading preferences:', error);
      }
    }
  }, []);

  const handleToggle = (category, key) => {
    setPreferences((prev) => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: !prev[category][key],
      },
    }));
    setHasChanges(true);
  };

  const handleMainToggle = () => {
    setPreferences((prev) => ({
      ...prev,
      receiveEmails: !prev.receiveEmails,
    }));
    setHasChanges(true);
  };

  const savePreferences = () => {
    localStorage.setItem('physCommunicationPrefs', JSON.stringify(preferences));
    setHasChanges(false);
    console.log('Preferences saved:', preferences);
  };

  return (
    <div className="communications">
      <h2 className="communications__title">
        Preferencias de suscripción e intereses
      </h2>

      <div className="communications__email">
        <span className="communications__email-label">Correo electrónico</span>
        <span className="communications__email-value">{customer?.email}</span>
      </div>

      <div className="communications__section">
        <label className="communications__checkbox">
          <input
            type="checkbox"
            checked={preferences.receiveEmails}
            onChange={handleMainToggle}
          />
          <span className="communications__checkbox-custom"></span>
          <div className="communications__checkbox-content">
            <span className="communications__checkbox-title">
              Recibir comunicaciones por correo
            </span>
            <span className="communications__checkbox-desc">
              Estás suscrito para recibir comunicaciones sobre nuestros productos, servicios e intereses.
            </span>
          </div>
        </label>
      </div>

      <div className="communications__group">
        <h3 className="communications__group-title">Intereses</h3>
        <p className="communications__group-desc">
          Ajusta tus intereses para recibir comunicaciones personalizadas.
        </p>

        <div className="communications__options">
          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.interests.eventsAndCommunity}
              onChange={() => handleToggle('interests', 'eventsAndCommunity')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                Eventos y comunidad
              </span>
              <span className="communications__checkbox-desc">
                Invitaciones a eventos de productos y comunidad, e información sobre promociones.
              </span>
            </div>
          </label>

          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.interests.culturalMatters}
              onChange={() => handleToggle('interests', 'culturalMatters')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                Temas culturales
              </span>
              <span className="communications__checkbox-desc">
                Recomendaciones mensuales para leer, ver y escuchar en tu tiempo libre.
              </span>
            </div>
          </label>

          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.interests.inHouseKnowledge}
              onChange={() => handleToggle('interests', 'inHouseKnowledge')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                Conocimiento interno
              </span>
              <span className="communications__checkbox-desc">
                Información sobre productos, consejos personalizados y guías de uso de nuestras formulaciones.
              </span>
            </div>
          </label>
        </div>
      </div>

      <div className="communications__group">
        <h3 className="communications__group-title">Sensibilidades estacionales</h3>
        <p className="communications__group-desc">
          Te ofrecemos la posibilidad de excluirte de comunicaciones relacionadas con ciertas ocasiones.
        </p>

        <div className="communications__options">
          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.seasonalSensitivities.mothersDay}
              onChange={() => handleToggle('seasonalSensitivities', 'mothersDay')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                Día de las Madres
              </span>
              <span className="communications__checkbox-desc">
                Recibir comunicaciones relacionadas con el Día de las Madres.
              </span>
            </div>
          </label>

          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.seasonalSensitivities.fathersDay}
              onChange={() => handleToggle('seasonalSensitivities', 'fathersDay')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                Día del Padre
              </span>
              <span className="communications__checkbox-desc">
                Recibir comunicaciones relacionadas con el Día del Padre.
              </span>
            </div>
          </label>

          <label className="communications__checkbox">
            <input
              type="checkbox"
              checked={preferences.seasonalSensitivities.valentinesDay}
              onChange={() => handleToggle('seasonalSensitivities', 'valentinesDay')}
            />
            <span className="communications__checkbox-custom"></span>
            <div className="communications__checkbox-content">
              <span className="communications__checkbox-title">
                San Valentín
              </span>
              <span className="communications__checkbox-desc">
                Recibir comunicaciones relacionadas con San Valentín.
              </span>
            </div>
          </label>
        </div>
      </div>

      {hasChanges && (
        <div className="communications__actions">
          <button className="communications__save-btn" onClick={savePreferences}>
            Guardar preferencias
          </button>
        </div>
      )}
    </div>
  );
};

export default Communications;
